import { getTransactionAnalytics } from '@ynap/analytics'

export const trackPaymentSelect = (option, checkoutAnalytics) => {
    const { description, cardId } = option
    return {
        event: cardId ? 'saved card payment' : description.toLowerCase(),
        effect: 'select payment',
        category: {
            subCategory: 'payment',
        },
        transaction: getTransactionAnalytics(checkoutAnalytics),
    }
}

export const trackPayPalBASelect = (checked, checkoutAnalytics) => ({
    event: `${checked ? 'select' : 'remove'} paypal faster payment`,
    effect: `${checked ? 'activate' : 'deactivate'} paypal faster payment for future purchases`,
    category: {
        primaryCategory: 'checkout',
        subCategory: 'payment',
    },
    transaction: getTransactionAnalytics(checkoutAnalytics),
})

export default {
    trackPaymentSelect,
}
